import { Component } from '@angular/core';
import { User } from '../../authentication/model/user.model';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser } from '../../authentication/store/user.selector';
import MenuOption from '../model/menu-option';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs/operators';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-user-widget',
  template: `
    @if (user$ | async; as user) {
    <sibat-widget title="{{ user.firstName }} {{ user.lastName }}" subtitle="{{ user.email }}" [menu]="menu$ | async">
      <mat-icon widget-icon>account_circle</mat-icon>
      <dl widget-content>
        <div>
          <dt>{{ 'cockpit.role' | transloco }}</dt>
          <dd>{{ 'cockpit.userRole' | transloco : { role: user.activeRole } }}</dd>
        </div>
      </dl>
    </sibat-widget>
    }
  `,
  styleUrls: ['user-widget.component.scss'],
  imports: [WidgetComponent, MatIcon, TranslocoPipe, AsyncPipe],
})
export class UserWidgetComponent {
  user$: Observable<User | undefined>;
  menu$: Observable<MenuOption[]>;

  constructor(private store: Store, private translocoService: TranslocoService) {
    this.user$ = this.store.select(selectUser);
    this.menu$ = this.translocoService
      .selectTranslate('cockpit.changePassword')
      .pipe(map(value => [{ route: '/changePassword', text: value }]));
  }
}
